module.exports = __webpack_public_path__ + "media/images/blog/photo-sample-0b4d0968b829024dfbaa4c9a34a207cc.jpg";